import { DefaultApi, Configuration } from '../generated-api';

const defaultBasePath =
  `${window.location.protocol}//${window.location.host}`;

class LimberApi extends DefaultApi {
  constructor(basePath: string = defaultBasePath) {
    super(new Configuration({
      basePath,
    }));
  }
}

const api = new LimberApi(
  (window as { __limberApiBasePath?: string }).__limberApiBasePath,
);
export default api;
